import { LoggedIssueModel, PagedListingResponseOfAdminTourModel } from './../../core/services/api.service';
import { TourLocked } from "@core/models/tour-locked/tour-locked.model";
import { DistanceModel, GetAdminTourListQuery, GetTourHistoryQuery, NotesModel, PagedListingResponseOfTourListHistoryModel, TourHistoryModel, TourLockedModel, TourModel, TourVehicleRouteModel, UpdateTrackingUrlCommand } from "@core/services/api.service";



export class LoadAdminTourListAction {
    static readonly type = '[AdminTourList] Load Admin Tour list';
    constructor(public payload: { GetAdminTourListQuery: GetAdminTourListQuery }) { }
}

export class LoadAdminTourListSuccessAction {
    static readonly type = '[AdminTourList] Load Admin Tour list Success';

    constructor(public payload: { adminTourList: PagedListingResponseOfAdminTourModel }) { }
}

export class LoadAdminTourListFailAction {
    static readonly type = '[AdminTourList] Load Admin Tour list Fail';
}
export class LoadTourListAction {
    static readonly type = '[ManagedTourList] Load Tour list';
}

export class LoadTourListSuccessAction {
    static readonly type = '[ManagedTourList] Load Tour list Success';

    constructor(public payload: { tours: TourModel[] }) { }
}

export class LoadTourListFailAction {
    static readonly type = '[ManagedTourList] Load Tour list Fail';
}

export class SetCategoryFilterAction {
    static readonly type = '[ManagedTourList] Set Category Filter';
    constructor(public payload: { selectedCategory: string }) { }
}

export class SetShipmentModeAction {
    static readonly type = '[ManagedTourList] Set  Filter';
    constructor(public payload: { selectedMode: string[] }) { }
}

export class SetDepartmentsFilterAction {
    static readonly type = '[ManagedTourList] Set Departments Filter';
    constructor(public payload: { selectedDepartments: number[] }) { }
}

export class SetTypesFilterAction {
    static readonly type = '[ManagedTourList] Set Type Filter';
    constructor(public payload: { selectedTypes: number[] }) { }
}

export class SetOwningUserFilterAction {
    static readonly type = '[ManagedTourList] Set Owning User Filter';
    constructor(public payload: { selectedOwningUsers: string[] }) { }
}

export class ApplyFiltersToToursAction {
    static readonly type = '[ManagedTourList] Apply filter to tours';
}

export class ApplyFiltersToAdminToursAction {
    static readonly type = '[ManagedTourList] Apply filter to Admin tours';
}
export class RegisterSignalRHandlersForTourAction {
    static readonly type = '[TourList] Register SignalR Handlers For Tours';
}


//start
export class GetTourByIdAction {
    static readonly type = '[Tours] Get Tour By ID';

    constructor(public tourId: number, public transportOrderNumber?: string | null) { }
}

export class GetTourByIdSuccessAction {
    static readonly type = '[Tours] Get Tour By ID Success';

    constructor(public payload: TourModel) { }
}

export class GetTourByIdFailAction {
    static readonly type = '[Tours] Get Tour By ID Fail';
}
//end

//Update ETA
export class UpdateETAAction {
    static readonly type = '[Tours] Update ETA';

    constructor(public tourId: number, public estimatedDateTime: Date | undefined, public updateType: number, public note: string ,public latitude: number,public longitude: number, public vehicleDuration: string, public vehicleDistance: string, public address: string, public restStartTime: Date | undefined,public restEndTime: Date | undefined, public historyId: number, public transportOrderNumber: string | null | undefined) { }
}

export class UpdateETASuccessAction {
    static readonly type = '[Tours] Update ETA Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class UpdateETAFailAction {
    static readonly type = '[Tours] Update ETA Fail';
}
//end

//Assign User
export class AssignUserAction {
    static readonly type = '[Tours] Assign User';

    constructor(public id: number, public userId: string | undefined) { }
}

export class AssignUserSuccessAction {
    static readonly type = '[Tours] Assign User Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class AssignUserFailAction {
    static readonly type = '[Tours] Assign User Fail';
}

export class AssignVehicleAction {
    static readonly type = '[Vehicles] Assign Vehicle';

    constructor(public id: number, public vehicleId: number | undefined) { }
}

export class AssignVehicleSuccessAction {
    static readonly type = '[Vehicles] Assign Vehicle Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class AssignVehicleFailAction {
    static readonly type = '[Vehicles] Assign Vehicle Fail';
}
export class UnCancelTourAction {
    static readonly type = '[Tour] UnCancel tour action';

    constructor(public id: number) { }
}

export class UnCancelTourSuccessAction {
    static readonly type = '[Tour] UnCancel tour Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class UnCancelTourFailAction {
    static readonly type = '[Tour] UnCancel tour Fail';
}
export class CancelTourAction {
    static readonly type = '[Tour] Cancel tour action';

    constructor(public id: number) { }
}

export class CancelTourSuccessAction {
    static readonly type = '[Tour] Cancel tour Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class CancelTourFailAction {
    static readonly type = '[Tour] Cancel tour Fail';
}
//end

//Cancel tour
export class MakeTourCriticalAction {
    static readonly type = '[Tour] Make tour critical action';

    constructor(public id: number, public isCritical: boolean) { }
}

export class MakeTourCriticalSuccessAction {
    static readonly type = '[Tour] Make tour critical Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class MakeTourCriticalFailAction {
    static readonly type = '[Tour] Make tour critical Fail';
}
//end
//HeldAtCustoms tour
export class MakeTourHeldAtCustomsAction {
    static readonly type = '[Tour] Make tour held at customs action';

    constructor(public id: number, public HeldAtCustoms: boolean) { }
}

export class MakeTourHeldAtCustomsSuccessAction {
    static readonly type = '[Tour] Make tour held at customs Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class MakeTourHeldAtCustomsFailAction {
    static readonly type = '[Tour] Make tour held at customs Fail';
}
//end

//HeldAtCustoms tour
export class UpdateTrackingFreqAction {
    static readonly type = '[Tour] Update Tracking Frequency action';

    constructor(public id: number, public frequencyId: number) { }
}

export class UpdateTrackingFreqSuccessAction {
    static readonly type = '[Tour] Update Tracking Frequency Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class UpdateTrackingFreqFailAction {
    static readonly type = '[Tour] Update Tracking Frequency Fail';
}
//end

// New notes actions
export class GetNotesAction {
    static readonly type = '[Notes] Get Notes';

    constructor(public tourId: number) { }
}

export class GetNotesSuccessAction {
    static readonly type = '[Notes] Get Notes Success';

    constructor(public payload: NotesModel[]) { }
}

export class GetNotesFailAction {
    static readonly type = '[Notes] Get Notes Fail';
}

export class AddNoteAction {
    static readonly type = '[Notes] Add Note';

    constructor(public id: number, public tourId: number, public note: string | null | undefined) { }
}

export class AddNoteSuccessAction {
    static readonly type = '[Notes] Add Note Success';

    constructor(public payload: NotesModel) { }
}

export class AddNoteFailAction {
    static readonly type = '[Notes] Add Note Fail';
}

export class UpdateTrackingUrlAction {
    static readonly type = '[Notes] Add UpdateTrackingUrl';

    constructor(public model: UpdateTrackingUrlCommand) { }
}

export class UpdateTrackingUrlSuccessAction {
    static readonly type = '[Notes] UpdateTrackingUrl Success';
}

export class UpdateTrackingUrlFailAction {
    static readonly type = '[Notes] UpdateTrackingUrl Fail';
}


export class CalculateDistanceAction {
    static readonly type = '[Notes] Add CalculateDistance';

    constructor(public fromLat: number, public fromLng: number, public toLat: number, public toLng: number, public maxSpeed: number) { }
}

export class CalculateDistanceSuccessAction {
    static readonly type = '[Notes] CalculateDistance Success';

    constructor(public distanceModel: DistanceModel) { }
}

export class CalculateDistanceFailAction {
    static readonly type = '[Notes] CalculateDistance Fail';
}

export class LoadTourHistoryListAction {
    static readonly type = '[TourHistoryList] Load Tour History list';
    constructor(public payload: { GetTourHistoryQuery: GetTourHistoryQuery }) { }
}

export class LoadTourHistoryListSuccessAction {
    static readonly type = '[TourHistoryList] Load Tour History list Success';

    constructor(public payload: { tourHistoryList: PagedListingResponseOfTourListHistoryModel }) { }
}

export class LoadTourHistoryListFailAction {
    static readonly type = '[TourHistoryList] Load Tour History list Fail';
}

export class UpdateTourAction {
    static readonly type = '[TourList] Update Tour';

    constructor(public payload: { tour: TourModel }) { }
}
export class LoadTourUpdateHistoryAction {
    constructor(public entityId: number | undefined) { }
    static readonly type = '[TourUpdateHistory] Load Tour Update History';
}

export class LoadTourUpdateHistorySuccessAction {
    static readonly type = '[TourUpdateHistory] Load Tour Update History Success';

    constructor(public payload: { tourUpdateHistory: TourHistoryModel[] }) { }
}

export class LoadTourUpdateHistoryFailAction {
    static readonly type = '[TourUpdateHistory] Load Tour Update History Fail';
}

//HeldAtCustoms tour
export class MarkTourCompletedAction {
    static readonly type = '[Tour] Mark Tour Completed action';

    constructor(public id: number) { }
}

export class MarkTourCompletedSuccessAction {
    static readonly type = '[Tour] Mark Tour Completed Success';

    constructor(public payload: { tour: TourModel }) { }
}

export class MarkTourCompletedFailAction {
    static readonly type = '[Tour] Mark Tour Completed Fail';
}
//end

//start
export class SaveRouteAction {
    static readonly type = '[Route] Save tour route Completed action';

    constructor(public TourId: number, public VehicleId: number, public RouteData: string, public EventTrigger: string, public SuggestedETA: Date | undefined, public Distance: string) { }
}

export class SaveRouteSuccessAction {
    static readonly type = '[Route]Save tour route Completed Success';

    constructor(public payload: { route: TourVehicleRouteModel }) { }
}

export class SaveRouteFailAction {
    static readonly type = '[Route] Save tour route Completed Fail';
}
//end

//start
export class GetRouteByTourIdAction {
    static readonly type = '[Route] Get tour route Completed action';

    constructor(public TourId: number) { }
}

export class GetRouteByTourIdSuccessAction {
    static readonly type = '[Route] Get tour route Completed Success';

    constructor(public payload: { route: TourVehicleRouteModel }) { }
}

export class GetRouteByTourIdFailAction {
    static readonly type = '[Route] Get tour route Completed Fail';
}
//end

export class AuditGoogleApiAction {
    static readonly type = '[TourLock] AuditGoogleApiAction';

    constructor(public updateType: string) { }
}

//start
export class TourLockHistoryByIdAction {
    static readonly type = '[TourLock] Add TourLock History Completed action';

    constructor(public tourId: number) { }
}

export class TourLockHistoryByIdSuccessAction {
    static readonly type = '[TourLock] Add TourLock History Success';

    constructor(public payload: { model: TourLockedModel }) { }
}
export class TourLockHistoryByIdFailAction {
    static readonly type = '[TourLock] Add TourLock History Fail';
}
//end

//start
export class RemoveTourLockByIdAction {
    static readonly type = '[TourLock] RemoveTourLockByIdAction';

    constructor(public tourId: number) { }
}

export class RemoveTourLockByIdSuccessAction {
    static readonly type = '[TourLock] RemoveTourLockByIdSuccessAction';
}
export class RemoveTourLockByIdFailAction {
    static readonly type = '[TourLock] RemoveTourLockByIdFailAction';
}
//end

//start
export class CreateTourHistoryByTourIdAction {
    static readonly type = '[TourHistory] Create Tour History Action';

    constructor(public payload: { tourId: number,
        note: string,
        isApproved: boolean,
        updateTypeLookupId: number,
        requiresValidation: boolean,
        rejectionComments: string,
        eta: Date,
        vehicleLat: number,
        vehicleLng: number,
        vehicleDur: string,
        vehicleDistance: string,
        place: string}) { }
}

export class CreateTourHistoryByTourIdSuccessAction {
    static readonly type = '[TourHistory] Create Tour History SuccessAction';
    constructor(public payload: { tourHistory: TourHistoryModel }) { }
}
export class CreateTourHistoryByTourIddFailAction {
    static readonly type = '[TourHistory] Create Tour History FailAction';
}
//end

//start
export class UpdateHistoryItemByIdAction {
    static readonly type = '[TourHistory] Update Tour History Action';

    constructor(public payload: { tourId: number, note: string, isApproved: boolean, requiresValidation: boolean, rejectionComments: string, eta: Date, isEdit: boolean }) { }
}

export class UpdateHistoryItemByIdSuccessAction {
    static readonly type = '[TourHistory] Update Tour History SuccessAction';
    constructor(public payload: { tourHistory: TourHistoryModel }) { }
}
export class UpdateHistoryItemByIdFailAction {
    static readonly type = '[TourHistory] Update Tour History FailAction';
}
//end

//start
export class DisableHistoryItemIdAction {
    static readonly type = '[TourHistory] Disable History Item Action';

    constructor(public id: number, public tourId: number) { }
}

export class DisableHistoryItemIdSuccessAction {
    static readonly type = '[TourHistory] Disable History Item SuccessAction';
}
export class DisableHistoryItemIdFailAction {
    static readonly type = '[TourHistory] Disable History Item FailAction';
}
//end

//HeldAtCustoms tour
export class LogAnIssueAction {
    static readonly type = '[LogAnIssue] Log an Issue Action';

    constructor(public tourId: number,
        public causeOfIssue: string,
        public impact: string,
        public reasonForIssue: string,
        public isLoggedByCustomer: boolean,
        public hasCustomerBeenCalled: boolean,
        public hasCarrierBeenCalled: boolean,
        public notes: string,
        public eta: Date,
        public historyId: number,
        public tourHistoryId: number,
        public status: boolean,
        public escalateIssue: boolean,
        public isControlRoom: boolean,
        public managerActions: string,
        public issueActions: string,
        public priority: string) { }
}

export class LogAnIssueSuccessAction {
    static readonly type = '[LogAnIssue] Log an Issue Success action';
}

export class LogAnIssueFailAction {
    static readonly type = '[LogAnIssue] Log an Issue Fail action';
}
//end

export class LoadLoggedIssuesAction {
    static readonly type = '[LoggedIssues] Load Logged issues';

    constructor(public tourId: number ) { }
}

export class LoadLoggedIssuesSuccessAction {
    static readonly type = '[LoggedIssues] Load logged issues Success';

    constructor(public payload: { tours: LoggedIssueModel[] }) { }
}

export class LoadLoggedIssuesFailAction {
    static readonly type = '[LoggedIssues] Load logged issues Fail';
}


export class RegisterSignalRHandlersForChatShAction {
    static readonly type = '[EscalationChatShipment] Register SignalR Handlers For Escalation Chat shipment';
}


export class AddNotificationSh {
    static readonly type = '[EscalationChatShipment] Add Escalation Chat Shipment';
    constructor(public payload: { message: string; tourId: number }) {}
}

export class RemoveNotificationSh {
    static readonly type = '[EscalationChatShipment] Remove Escalation Chat Shipment';
    constructor(public tourId: number) {}
}

export class CloseIssueAction {
    static readonly type = '[CloseIssue] Close Issue Action';
    constructor(public id: number, public tourId: number) {}
}

export class CloseIssueSuccessAction {
    static readonly type = '[CloseIssue] Close Issue Success Action';
}

export class CloseIssueFailAction {
    static readonly type = '[CloseIssue] Close Issue Fail Action';
}

export class ClearSelectedTourAction {
    static readonly type = '[Tours] Clear Selected Tour';
}

//start
export class AddTrailerRegByTourIdAction {
    static readonly type = '[Tour] Add Trailer Registration By TourId';
    constructor(public id: number, public regNumber: string | null | undefined) { }
}

export class AddTrailerRegByTourIdSuccessAction {
    static readonly type = '[Tour] Add Trailer Registration By TourId Success';
    constructor(public payload: { tour: TourModel }) { }
}

export class AddTrailerRegByTourIdFailAction {
    static readonly type = '[Tour] Add Trailer Registration By TourId Fail';
}
//end

// New Customs Messages Notification for Managed Tours
export class SetHasNewCustomsMessagesForManagedToursAction {
    static readonly type = '[ManagedTours] Set Has New Customs Messages';
    constructor(public payload: { hasNewMessages: boolean }) { }
}

export class ClearNewCustomsMessagesForManagedToursAction {
    static readonly type = '[ManagedTours] Clear New Customs Messages';
}